import ZtServiceFactory from '../../../../services/zt';
// import ZtServiceFactory from '../../../../services/json';

const $ztService = ZtServiceFactory.getDefaultInstance();

/**
 * 预约
 * @param params
 * @returns {Promise<{session_id: "1FgDfGnYqhBqq8HfPpp27n1281halWQn7Eue11SI", request_id: "2adea4796261580907e068582b92958dc24fcb8f"}>}
 */
const submitAsync = params => {
  return $ztService.subscribeByGw(params);
};

const Service = {
  submitAsync,
  getEmailCode: $ztService.getEmailCode
};
export default Service;
